import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

function Experience({ duration, position, description, workPlace }) {
  return (
    <div className="resume-experience-item">
      <span className="resume-experience-item-time">
        <FontAwesomeIcon icon={faCalendar} className="mr-2" /> {duration}
      </span>
      <h3>{position}</h3>
      <p>{description}</p>
      <span className="resume-experience-item-source">{workPlace}</span>
    </div>
  );
}

export default Experience;
